var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009CF2",
    d: "M9.51 7.132a.34.34 0 0 1 0-.437l2.224-2.713a.343.343 0 0 1 .532 0l2.228 2.713a.34.34 0 0 1 0 .437l-2.228 2.635a.343.343 0 0 1-.532 0L9.506 7.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00649B",
    d: "M9.51 17.383a.34.34 0 0 1 0-.437l2.224-2.713a.344.344 0 0 1 .532 0l2.228 2.713a.34.34 0 0 1 0 .437l-2.228 2.636a.343.343 0 0 1-.532 0l-2.228-2.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009CF2",
    d: "M6.296 11.216a.34.34 0 0 1-.005-.437L8.5 8.066a.343.343 0 0 1 .531 0l2.207 2.713a.34.34 0 0 1 0 .437l-2.211 2.636a.343.343 0 0 1-.523 0zm6.471 0a.34.34 0 0 1 0-.437l2.203-2.713a.343.343 0 0 1 .531 0l2.208 2.713a.34.34 0 0 1 0 .437l-2.212 2.636a.343.343 0 0 1-.523 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsv);
export default __webpack_public_path__ + "static/media/ssv.c859ea6df083fbd068f35ed84130cb85.svg";
export { ForwardRef as ReactComponent };